// extracted by mini-css-extract-plugin
module.exports = {"product":"Product_product__2kK__","promo-container":"Product_promo-container__10ypn","menu":"Product_menu__34WTF"};